


































import openApp from '@ivy/fts/openApp'
import { toItem } from '../../helper'
import { Component, Vue, Prop } from "vue-property-decorator"
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import showApp from '../../components/showApp.vue'
@Component
export default class DownloadApp extends Vue {
  @Prop() data: any
  @Prop() type: any
  @Prop() index: any
  @Prop() albumId: any
  @Prop() memId: any
  @Prop() share_username: any

  get access() {
    if (!this.data.access_type || this.data.access_type === 'free') return { text: '', style: '' }
    let key = ''
    if (+this.data.listen === 1) {
      key = 'listen'
    } else if (['vip', 'sale_vip'].includes(this.data.access_type)) {
      key = 'vip'
    } else if (this.data.access_type === 'sale') {
      key = 'sale'
    }
    let style = {
      listen: { backgroundImage: `url(${require("../../assets/album_trylisten@3x.png")})` },
      vip: { backgroundImage: `url(${require("../../assets/album_member@3x.png")})` },
      sale: { backgroundImage: `url(${require("../../assets/album_pay@3x.png")})` },
    }
    let text = { listen: '试听', vip: '会员', sale: '付费' }
    return { text: text[key], style: style[key] }
  }
  get playcount() {
    return this.data.playcount > 9999 ? `${(this.data.playcount / 10000).toFixed(1)}万` : this.data.playcount
  }
  get from() {
    let from: any = this.$route.query.from
    return ['timeline', 'groupmessage', 'singlemessage'].includes(from) ? 'share' : this.$route.query.from
  }
  toItem() {
    const opt = { data: this.data, type: this.type, from: this.from, albumId: this.albumId, memId: this.memId, share_username: this.share_username }
    toItem(opt)
  }
  async toApp() {
    showDiv(showApp, {
      closeAll
    })
  }
}
